/**
 * Language Specific vars and dictionary
 * ESP - Spanish
 * ENG - English
 */

declare const LANG: string;
declare const URL_BASE: string; 

import { reservaT, reservaD } from "./variables.js";

// !REMOVE BELOW - SAVE FOR NOW TO SEARCH WHEN ERRORS OCCUR: 
// const pageResURL = "http://localhost/furauto/alquiler-busqueda/";
// // pageResURL = "/alquiler-busqueda/";

// const pMonth = ["enero", "febrero", "marzo", "abril", "mayo", "junio", 
//           "julio", "agosto", "septiempre", "octubre", "noviembre", "diciembre"];

// const pDay = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];

let pag_lang :string;               // Page Lang
let src_lang :string;               // Search Lang (results)

let reservaTextos: any = {};        // Form variable texts
let langDict: string[] = [];             // On screen texts and messages

function setDict() {

    reservaTextos = variableDefinitions();

    if (LANG=="ENG") {

        langDict = langdict("en");

        pag_lang = "en";    
        src_lang = "ENG";   

    } else {

        langDict = langdict("es");

        pag_lang = "es";    
        src_lang = "ESP";   

    }


    // Default Values:
    const keys = Object.keys(reservaTextos)
    keys.forEach( e => {
        reservaD[ parseInt(e) ] = "";
        reservaT[ parseInt(e) ] = reservaTextos[e];
    });
	
}

// These are for debug purposes only:
function variableDefinitions() {

    const reservaTextos = {
        0: "Fecha Petición",
        1: "Fecha Desde",
        2: "Hora Desde",
        3: "Fecha Hasta",
        4: "Hora Hasta",
        5: "Duración (Dias)",
        6: "Prov.",
        7: "Tipo Vehículo",
        8: "One Way",
        9: "SQL Desde",
        10: "SQL Hasta",
        11: "Prov. Dev.",
        12: "Ciu. Rec.",
        13: "Ciu. Dev.",
        14: "Edad Conductor 25-70",
        15: "Provincia sal ID", // Added 2024-01
        16: "Provincia dev ID", // Added 2024-01
        20: "id Vehiculo",
        21: "id Proveedor",
        22: "Proveedor",
        23: "id Grupo",
        24: "modelo",
        25: "km incluidos",
        26: "Cuota € /dia",
        27: "Cuota oneway",
        28: "Comision € / dia",
        29: "KM Max per res.",       // Added 2024-01

        30: "Sup res.",
        31: "Precio Sup",
        32: "Desc res.",
        33: "Precio Desc",
        34: "Young Driver - Dia", // Added 2024-01
        35: "Young Driver - Max", // Added 2024-01

        36: "Pais Rec",     // 2024-07: To distinguish between ES and FR
        37: "Pais Dev",     // 2024-07: To distinguish between ES and FR


        40: "id ofi. Rec.",
        41: "id ofi. Dev",
        42: "Nombre",
        43: "Correo",
        44: "Telefono",
        45: "id punto rec.",
        46: "Punto Rec.",
        47: "Sup. Rec.",
        48: "id punto dev.",
        49: "Punto Dev.",

        50: "Sup. Dev.",
        51: "Horario Rec.",
        52: "Horario Dev.",
        53: "Horario ofi. Rec.", // Added 2024-01
        54: "Horario ofi. Dev.", // Added 2024-01
        
        60: "Precio Alquiler",
        61: "Precio Sup",       // same?
        62: "IVA",
        63: "Precio Final",
        64: "Pago Parcial",
        65: "nº Vuelo",
        66: "Newsletter",

        70: "Nombre Cl",
        71: "Correo Cl",
        72: "Telefono Cl",
        73: "DNI Cl",
        74: "Msg Cl",
        75: "Pago Previo",
        76: "Pago ofi.",
        77: "Forma de Pago",
        78: "Pago Parcial %",

        80: "Id Ext. (XML)",
        81: "Origen res.",
        82: "Revendor Code",
        83: "total Search count",   // used to hold RVKEY / ID (now all in 82)
        84: "override defaults",
        85: "ga4_uid",
        86: "Lang",
        87: "pgid",
        88: "token",
        
        95: "Client SMS Code",
        96: "ga5_uid (afid)",

    };

    return reservaTextos;
}

function langdict(lang:string = "es") :string[] {

    let langJson :string[] = [];

    fetch( URL_BASE + "/js/dict/" + lang + ".json")
    .then( (res) => {
        return res.json();
    }).
    then( (json) => {

        // Convert json keys to numeric array: 
        let keys = Object.keys(json);
        keys.forEach( e => {
            langJson[ parseInt(e) ] = json[e];
        });
        return (langJson);
    })
    .catch( (err) => {
        console.error("FATAL ERROR LOADING DICTIONARY!!");
    });

    return (langJson);

}



export { pag_lang, src_lang, reservaTextos, langDict, setDict };